import { createContext, useContext, type RefObject } from 'react';

import type { SlotRegistry } from './slot-registry.js';

/** @internal */
export interface PageLayoutPortalContextValue {
  hosts: {
    header: HTMLDivElement;
    sidebar: HTMLDivElement;
    content: HTMLDivElement;
    details: HTMLDivElement;
  };
  /**
   * Stable refs to the two layout container elements. The slot components
   * measure these directly instead of receiving a width through the registry,
   * which would make them subscribers to the store they publish to.
   */
  containers: {
    sidebar: RefObject<HTMLDivElement | null>;
    details: RefObject<HTMLDivElement | null>;
  };
  registry: SlotRegistry;
}

/** @internal */
export const PageLayoutPortalContext =
  createContext<PageLayoutPortalContextValue | null>(null);

/** @internal */
export function usePageLayoutPortalContext(): PageLayoutPortalContextValue {
  const ctx = useContext(PageLayoutPortalContext);
  if (ctx === null) {
    throw new Error(
      'PageLayout slot components (Header, Sidebar, Content, Details) must be rendered inside a <PageLayout>.',
    );
  }
  return ctx;
}
